module.exports = __webpack_public_path__ + "img/file-earmark-post.f744af43.svg";